import React, { useState } from "react";
import { useCreate } from "@pankod/refine-core";
import {
  Alert,
  Button,
  Form,
  Input,
  Modal,
  notificationProvider,
  Select,
  Space,
} from "@pankod/refine-antd";

/**
 * Toggles the `isHiddenFromUser` flag on a single listed vendor via
 * `pvtUpdateListedVendorForKodoPay(input: UpdateVendorInput)`, by vendor id (copy it from the AMC
 * collection accounts table). The backend rejects unhiding an AMC collection account.
 */
export const UpdateVendorVisibilityModal: React.FC<{ onUpdated?: () => void }> = ({ onUpdated }) => {
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();
  const { mutate, isLoading } = useCreate();

  const close = () => {
    form.resetFields();
    setOpen(false);
  };

  const handleFinish = (values: { vendorId: string; isHiddenFromUser: boolean }) => {
    mutate(
      {
        resource: "pvtUpdateListedVendorForKodoPay",
        dataProviderName: "grapghQl",
        values: {
          input: {
            vendorId: values.vendorId.trim(),
            isHiddenFromUser: values.isHiddenFromUser,
          },
        },
        successNotification: false,
        errorNotification: false,
      },
      {
        onSuccess: () => {
          notificationProvider.open({
            message: values.isHiddenFromUser
              ? "Vendor hidden from users"
              : "Vendor is now visible to users",
            type: "success",
            description: "",
          });
          close();
          onUpdated?.();
        },
        onError: (err: any) => {
          notificationProvider.open({
            message: err?.message || "Update failed",
            type: "error",
            description: "",
          });
        },
      },
    );
  };

  return (
    <Space>
      <Button onClick={() => setOpen(true)}>Hide / Unhide a Listed Vendor</Button>

      <Modal
        title="Update Listed Vendor Visibility"
        visible={open}
        centered
        width={480}
        onCancel={close}
        okText="Apply"
        okButtonProps={{ loading: isLoading }}
        onOk={() => form.submit()}
      >
        <Alert
          type="warning"
          showIcon
          style={{ marginBottom: 16 }}
          message="Enter the vendorId (listed vendor id) to hide or unhide it."
        />
        <Form
          form={form}
          layout="vertical"
          initialValues={{ isHiddenFromUser: true }}
          onFinish={handleFinish}
        >
          <Form.Item
            label="Vendor Id"
            name="vendorId"
            rules={[{ required: true, message: "Please enter the vendorId." }]}
          >
            <Input placeholder="Listed vendor id (UUID)" />
          </Form.Item>
          <Form.Item label="Visibility" name="isHiddenFromUser">

            <Select
              options={[
                { label: "Hide from users (isHiddenFromUser = true)", value: true },
                { label: "Show to users (isHiddenFromUser = false)", value: false },
              ]}
            />
          </Form.Item>
        </Form>
      </Modal>
    </Space>
  );
};
